// Pure helper for the Festival "Participer" (candidature) scheduling.
// Given the entry config and the current time, returns the candidature state:
//   "open"     → within the (optional) window, or no schedule active
//   "upcoming" → schedule active and now is before the opening date
//   "closed"   → schedule active and now is after the closing date
// An empty opening date means "already open"; an empty closing date means "no end".
export const computeApplyState = (entry = {}, now = Date.now()) => {
  if (!entry.applySchedule) return "open";
  const openTs = entry.applyOpen ? new Date(entry.applyOpen).getTime() : null;
  const closeTs = entry.applyClose ? new Date(entry.applyClose).getTime() : null;
  if (openTs && now < openTs) return "upcoming";
  if (closeTs && now > closeTs) return "closed";
  return "open";
};
